import { toRefs, computed } from 'vue';
import tinycolor from 'tinycolor2';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { useGroupItem } from '../../compositions/component-lib.esm18.js';
import { getThemeColor } from '../../styles/theme/component-lib.esm.js';

//
var script = {
  name: 'Radio',
  props: {
    value: String,
    hasError: Boolean,
    checked: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: '1rem'
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      color,
      value,
      size,
      checked,
      hasError
    } = toRefs(props);
    const theme = useTheme();
    const {
      isInGroup,
      onToggle,
      isSelected,
      inputName
    } = useGroupItem(value, 'radio-group');
    const isChecked = computed(() => {
      return isSelected.value || checked.value;
    });
    function handleChange(e) {
      emit('click', e);
      if (isInGroup) onToggle(value.value);
    }
    const styles = computed(() => {
      const themeColor = getThemeColor(hasError.value ? 'error' : color.value, theme.value);
      return {
        '--c-color': themeColor,
        '--c-bg-color': tinycolor(themeColor).setAlpha(0.05).toRgbString(),
        '--c-size': size.value
      };
    });
    return {
      styles,
      handleChange,
      isChecked,
      inputName
    };
  }
};
export { script as default };